<template>
    <div class="modal fade text-left" id="examModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="newExam">{{ $t("models.exam") }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form class="form">
                      <exam-form :exam="$store.state.currentExam" :exam-types="examTypes" ref="examForm" v-bind:typeId.sync="typeId" />
                      <div class="form-actions">
                        <button type="button" class="btn btn-success" @click.prevent="updateExam($refs.examForm.clonedExam)">
                            <i class="icon-note"></i> {{ $t("labels.save") }}
                        </button>
                        <button type="button" class="btn btn-warning" @click.prevent="deleteExam($refs.examForm.clonedExam)">
                          <i class="icon-note"></i> {{ $t("labels.delete") }}
                        </button>
                      </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeEventModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MedicalExamsService from '@/services/medicalExams'
import LovService from '@/services/lov'
import moment from 'moment'
import Progress from './Progress'
import ExamForm from '@/components/patient/ExamForm.vue'

export default {
    components: {
      Progress,
      ExamForm
    },
    data() {
      return {
        errors: [],
        typeId: '',
        examTypes: [],
      }
    },
     computed: {
        examType() {
            let result = this.examTypes.find(t => t._id === this.typeId)
            let tpval = {
                id: result._id,
                type: result.type,
                name: result.name
            }
            return tpval
        }
    },
    methods: {
        updateExam: async function(exam) {
            this.errors = []
            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            if (!exam.date) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.examDate")]))
            }
            if (!this.typeId || this.typeId.length === 0) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.examType")]))
            }
            if (exam.document && exam.document.type) {
                if (!this.$store.state.allowedFileTypes.includes(exam.document.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [exam.document.name]))
                }
                let fileSizeMb = exam.document.size/1024/1024
                if (fileSizeMb > 15) {
                    this.errors.push(this.$t("errors.tooLarge", [exam.document.name]))
                }
            }
            if (this.errors.length === 0) {
                exam.type = this.examType
                let formData = new FormData()
                formData.append('document', exam.document)
                formData.append('exam', JSON.stringify(exam))
                let result = await MedicalExamsService.update(formData)
                if (result.data.success) {
                    this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.exam")]))
                } else {
                    this.$miniToastr.error(this.$t("flash.updateFailed", [this.$t("models.exam")]))
                }
                this.$emit('updateexams')
                this.$emit('updateexamslist')
                this.$refs.closeEventModal.click()
            } else {
                this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
            loader.hide()
            this.$store.state.currentProgress = 0
        },
        deleteExam: async function(exam) {
            let result = await MedicalExamsService.delete(exam)
            if (result.data.success) {
                this.$miniToastr.success(this.$t("flash.deleteSuccess", [this.$t("models.exam")]))
                this.$emit('updateexams')
                this.$emit('updateexamslist')
                this.$refs.closeEventModal.click()
            } else {
                this.$miniToastr.error(this.$t("flash.deleteFailed", [this.$t("models.exam")]))
            }
        },
         getValues: async function(tp) {
            let examTypes = await LovService.all('medical_exams', false)
            if (examTypes) {
                this.examTypes = examTypes.data
            }
        },
    }
}
</script>



